import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';
import { Configurations } from '../../../models';

export const useUtmParams = (): Configurations['utmParams'] => {
  const state = useConstructorContextState();

  return get(state, ['utmParams'], {});
};
